/**
 * Created by CoolGuy on 2017/7/17.
 */
export default {
    name:"联系人",
    type:"contact"
};


// WEBPACK FOOTER //
// ./src/components/ContactList/const.js